export const CATEGORY_EMOJIS: readonly string[] = [
  '📺',
  '🎬',
  '🎵',
  '🎮',
  '📱',
  '💻',
  '☁️',
  '🌐',
  '🏠',
  '💡',
  '🚗',
  '✈️',
  '🛡',
  '🏥',
  '💊',
  '🏋️',
  '🎓',
  '📚',
  '🧾',
  '🏦',
  '💼',
  '🛒',
  '🐾',
  '🎁',
];
